
class ValidationHelper {
  constructor(schema, formSelector = 'form[data-turbo="false"][action*="advertisement_campaigns"]') {
    this.schema = schema;
    this.formSelector = formSelector;
    this.setupEventListeners();
  }

  setupEventListeners() {
    $(document).on('change', `${this.formSelector} input[type="file"]`, (e) => {
      if ($(e.target).closest(this.formSelector).length > 0) {
        if (e.target.files && e.target.files.length > 0) {
          this.validateField($(e.target));
        }
      }
    });
    
    $(document).on('blur change', `${this.formSelector} input:not([type="file"]), ${this.formSelector} textarea, ${this.formSelector} select`, (e) => {
      if ($(e.target).closest(this.formSelector).length > 0) {
        this.validateField($(e.target));
      }
    });
    
    $(document).on('input', `${this.formSelector} input, ${this.formSelector} textarea, ${this.formSelector} select`, (e) => {
      if ($(e.target).closest(this.formSelector).length > 0) {
        this.clearFieldError($(e.target));
      }
    });
  }

  validateField(field) {
    const fieldName = this.getFieldName(field);
    const value = field.val();
    
    if (fieldName) {
      const form = field.closest('form');
      const formData = this.getFormData(form);
      
      const result = this.schema.validateField(fieldName, value, formData);
      
      if (!result.valid) {
        const existingError = field.closest('.form-group, .field-group, .input-group, .col-12, .pl-31, .field_name, div').find('.validation-error');
        if (existingError.length === 0 || existingError.text() !== result.errors[0]) {
          this.showFieldError(fieldName, result.errors[0], field);
        }
      } else {
        this.hideFieldError(fieldName, field);
      }
    }
  }

  clearFieldError(field) {
    const fieldName = this.getFieldName(field);
    if (fieldName) {
      this.hideFieldError(fieldName, field);
    }
  }

  validateForm(form) {
    const formData = this.getFormData(form);
    
    const result = this.schema.validateFormWithConditions ? 
      this.schema.validateFormWithConditions(formData) : 
      this.schema.validateForm(formData);
    
    if (!result.valid) {
      this.showValidationErrors(result.errors);
      return false;
    } 
    
    return true;
  }

  getFieldName(field) {
    const name = field.attr('name');
    if (name) {
      if (name.includes('[') && name.includes(']')) {
        return name.replace(/.*\[([^\]]+)\].*/, '$1');
      }
      return name;
    }
    return null;
  }

  getFormData(form) {
    const data = {};
    form.find('input, textarea, select').each((index, element) => {
      const field = $(element);
      const name = field.attr('name');
      if (name) {
        const fieldName = this.getFieldName(field);
        if (field.attr('type') === 'checkbox') {
          if (!data[fieldName]) data[fieldName] = [];
          if (field.is(':checked')) {
            data[fieldName].push(field.val());
          }
        } else if (field.attr('type') === 'radio') {
          if (!data.hasOwnProperty(fieldName)) {
            data[fieldName] = '';
          }
          if (field.is(':checked')) {
            data[fieldName] = field.val();
          }
        } else {
          data[fieldName] = field.val();
        }
      }
    });
    return data;
  }

  showFieldError(fieldName, message, field) {
    this.hideFieldError(fieldName, field);
    
    const errorTarget = field.attr('data-error-target');
    let container;
    
    if (errorTarget) {
      container = field.closest(errorTarget);
    } else {
      container = field.closest('.form-group, .field-group, .input-group, .col-12, .pl-31, .field_name, div');
    }
    
    if (container && container.length > 0) {
      const errorDiv = $(`<div class="validation-error">${message}</div>`);
      container.append(errorDiv);
    } else {
      const errorDiv = $(`<div class="field-error"><div class="validation-error">${message}</div></div>`);
      field.after(errorDiv);
    }
    
    field.addClass('is-invalid');
  }


  hideFieldError(fieldName, field) {
    const allFields = $(`[name*="[${fieldName}]"]`);
    if (allFields.length > 1) {
      const container = allFields.first().closest('[data-group-container]');
      if (container.length > 0) {
        container.find('.validation-error').remove();
        return;
      }
    }
    
    if (field && field.length > 0) {
      const errorTarget = field.attr('data-error-target');
      let container;
      
      if (errorTarget) {
        container = field.closest(errorTarget);
      } else {
        container = field.closest('.form-group, .field-group, .input-group, .col-12, .pl-31, .field_name, div');
      }
      
      if (container && container.length > 0) {
        container.find('.validation-error').remove();
      }
      
      field.siblings('.field-error').remove();
      field.siblings('.validation-error').remove();
      
      field.removeClass('is-invalid');
    }
    
    $(`.${fieldName}-error`).remove();
  }

  showValidationErrors(errors) {
    $('.validation-error').remove();
    $('.is-invalid').removeClass('is-invalid');
    
    if (Array.isArray(errors)) {
      errors.forEach(error => {
        const errorDiv = $(`<div class="validation-error">${error}</div>`);
        $('form').prepend(errorDiv);
      });
    } else if (typeof errors === 'object') {
      Object.keys(errors).forEach(fieldName => {
        const fieldErrors = errors[fieldName];
        const errorMessage = Array.isArray(fieldErrors) ? fieldErrors[0] : fieldErrors;
        
        let field = $(`[name*="[${fieldName}]"]`);
        
        if (field.length === 0) {
          field = $(`[name*="${fieldName}"]`);
        }
        
        if (field.length === 0) {
          $('input, textarea, select').each((index, element) => {
            const $element = $(element);
            const name = $element.attr('name');
            if (name && this.getFieldName($element) === fieldName) {
              field = $element;
              return false;
            }
          });
        }
        
        if (field.length > 0) {
          if (field.length > 1) {
            const firstField = field.first();
            const container = firstField.closest('[data-group-container]');
            if (container.length > 0) {
              container.find('.validation-error').remove();
              const errorDiv = $(`<div class="validation-error">${errorMessage}</div>`);
              container.find('.field-error').append(errorDiv);
            } else {
              this.showFieldError(fieldName, errorMessage, field);
            }
          } else {
            this.showFieldError(fieldName, errorMessage, field);
          }
        }
      });
    }
  }

  clearAllErrors() {
    $(`${this.formSelector} .validation-error`).remove();
    $(`${this.formSelector} .field-error`).empty();
    $(`${this.formSelector} .is-invalid`).removeClass('is-invalid');
    
    $(`${this.formSelector} [data-group-container]`).each((index, element) => {
      const container = $(element);
      const fields = container.find('input[name*="["]');
      if (fields.length > 1) {
        container.find('.validation-error').remove();
      }
    });
  }
}

class FormHandler {
  constructor(formSelector, validationHelper) {
    this.form = $(formSelector);
    this.validationHelper = validationHelper;
    this.isSubmitting = false;
    this.setupFormSubmission();
  }

  setupFormSubmission() {
    this.form.off('submit');
    this.form.on('submit', (e) => {
      e.preventDefault();
      this.handleSubmit();
    });
  }

  handleSubmit() {
    if (this.isSubmitting) {
      return false;
    }

    const submitBtn = this.form.find('input[type="submit"]');
    const originalText = submitBtn.val() || submitBtn.text() || '入力内容確認';

    this.validationHelper.clearAllErrors();
    
    if (!this.validationHelper.validateForm(this.form)) {
      setTimeout(() => {
        submitBtn.prop('disabled', false).val(originalText);
      }, 100);
      return false;
    }
    
    this.isSubmitting = true;
    submitBtn.prop('disabled', true).val(submitBtn.data('disable-with') || '処理中...');
    
    this.submitForm(submitBtn, originalText);
  }

  submitForm(submitBtn, originalText) {
    const formData = new FormData(this.form[0]);
    
    $.ajax({
      url: this.form.attr('action'),
      type: this.form.attr('method') || 'POST',
      data: formData,
      processData: false,
      contentType: false,
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      success: (response) => {
        if (response.redirect_url) {
          window.location.href = response.redirect_url;
        } else {
          window.location.reload();
        }
      },
      error: (xhr) => {
        this.isSubmitting = false;
        this.handleError(xhr);
        submitBtn.prop('disabled', false).val(originalText);
      }
    });
  }

  handleError(xhr) {
    if (xhr.status === 422) {
      try {
        const response = JSON.parse(xhr.responseText);
        if (response.errors) {
          this.validationHelper.showValidationErrors(response.errors);
        } else {
          this.replaceForm(xhr.responseText);
        }
      } catch (e) {
        this.replaceForm(xhr.responseText);
      }
    } else {
      alert('エラーが発生しました。もう一度お試しください。');
    }
  }

  replaceForm(responseText) {
    const newForm = $(responseText).find('form[data-turbo="false"]');
    if (newForm.length > 0) {
      this.form.replaceWith(newForm);
      this.form = newForm;
      this.isSubmitting = false;
      this.setupFormSubmission();
    }
  }
}

window.ValidationHelper = ValidationHelper;
window.FormHandler = FormHandler;
